import styled from 'styled-components';
import { PropertyCardPhotoMixin } from '../../mixins/components/PropertyCardPhotoMixin';
export var StyledPropertyCardPhoto = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardPhoto",
  componentId: "c11n-8-111-1__sc-radyfj-0"
})(["", ""], PropertyCardPhotoMixin);